/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Creem_EnvironmentInputs */

const en_admin_settings_fields_creem_environment = /** @type {(inputs: Admin_Settings_Fields_Creem_EnvironmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environment`)
};

const zh_admin_settings_fields_creem_environment = /** @type {(inputs: Admin_Settings_Fields_Creem_EnvironmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`环境`)
};

/**
* | output |
* | --- |
* | "Environment" |
*
* @param {Admin_Settings_Fields_Creem_EnvironmentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_creem_environment = /** @type {((inputs?: Admin_Settings_Fields_Creem_EnvironmentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Creem_EnvironmentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_creem_environment(inputs)
	return zh_admin_settings_fields_creem_environment(inputs)
});
export { admin_settings_fields_creem_environment as "admin.settings.fields.creem_environment" }